import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import styles from './Footer.module.css';

export const Footer: React.FC = () => {
  const { t } = useLanguage();

  return (
    <footer className={styles.footer}>
      <div className={styles.footer__container}>
        <div className={styles.footer__content}>
          {/* Brand */}
          <div className={styles.footer__brand}>
            <div className={styles.footer__logo}>
              <span className={styles.footer__logoText}>INTEGROVA</span>
              <span className={styles.footer__logoAccent}>AI</span>
            </div>
            <p className={styles.footer__description}>
              {t.footer.description}
            </p>
          </div>

          {/* Links */}
          <div className={styles.footer__links}>
            <Link to="/company" className={styles.footer__link}>{t.footer.links.company}</Link>
            <span className={styles.footer__linkDivider}>|</span>
            <Link to="/contact" className={styles.footer__link}>{t.footer.links.social}</Link>
            <span className={styles.footer__linkDivider}>|</span>
            <Link to="/datenschutz" className={styles.footer__link}>{t.footer.links.privacy}</Link>
            <span className={styles.footer__linkDivider}>|</span>
            <Link to="/impressum" className={styles.footer__link}>{t.footer.links.impressum}</Link>
          </div>
        </div>

        <div className={styles.footer__divider} />

        <div className={styles.footer__bottom}>
          <p className={styles.footer__copyright}>
            {t.footer.copyright}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
